import {IS_LOGGED_IN} from "../types";
import call from './call';

export default (callback) => async (dispatch) =>
{
    const onResult= (result) =>
    {
        if(result)
            dispatch({type: IS_LOGGED_IN, payload: {auth: {logged: result[1].logged,role:result[1].role,userName:result[1].userName,isRA:result[1].ra,queryLimit:result[1].queryLimit}}});
        if (callback)
            callback();
    }
    dispatch(call("LoginService/isLoggedIn",{},onResult));
};